/**
 * This function is used to get the expiration time of the voided warning banner
 * We will keep the banner only for 2 days after the entry has settled
 * @param {string | undefined} settlementDate - the settlement date of an entry
 * @returns {number}
 */
export const getWarningBannerExpireTime = (settlementDate?: string) => {
    const oneDayInMilliseconds = 24 * 60 * 60 * 1000; //hours * minutes * seconds * milliseconds
    // the entry is still in progress if there is no settlement date available
    if (!settlementDate) {
        return 0;
    }

    return Date.parse(settlementDate) + 2 * oneDayInMilliseconds;
};
